import { Project } from '@core/domain/models/project.model'
import { User } from '@core/domain/models/user.model'
import { Id } from '@core/domain/types/id.type'
import { ProjectsRepository } from '@infrastructure/datasource/projects.repository'
export class ProjectsService {
  constructor(private _projectsRepository: ProjectsRepository) {}
  async create(data: { name: string }) {
    if (!data.name) throw Error('name is required')
    return this._projectsRepository.create(data)
  }

  async find(): Promise<Project[]> {
    return this._projectsRepository.find()
  }

  async createReview(projectId: Id, name: string): Promise<Project> {
    return this._projectsRepository.createReview(projectId, name)
  }

  async delete(projectId: Id): Promise<void> {
    return this._projectsRepository.delete(projectId)
  }

  async exportRis(projectId: Id, selectedReviewsIds: Id[]) {
    return this._projectsRepository.exportRis(projectId, selectedReviewsIds)
  }

  async exportCitationsDocx(projectId: Id, selectedReviewsIds: Id[]) {
    return this._projectsRepository.exportCitationsDocx(
      projectId,
      selectedReviewsIds
    )
  }

  async downloadPdfZip(
    projectId: Id,
    selectedReviewsIds: Id[]
  ): Promise<Blob> {
    return this._projectsRepository.downloadPdfZip(
      projectId,
      selectedReviewsIds
    )
  }

  async updateProjectName(projectId: Id, name: string): Promise<Project> {
    return this._projectsRepository.updateProjectName(projectId, name)
  }
  async updateContactForComplaintEmail(
    projectId: Id,
    email: string
  ): Promise<Project> {
    return this._projectsRepository.updateContactForComplaint(projectId, email)
  }
  async findProjectUsers(projectId: Id): Promise<User[]> {
    return this._projectsRepository.findProjectUsers(projectId)
  }

  async addUserToProject(projectId: Id, userId: Id): Promise<void> {
    return this._projectsRepository.addUserToProject(projectId, userId)
  }

  async updateCslStyle(projectId: Id, cslStyle: string): Promise<Project> {
    return this._projectsRepository.updateCslStyle(projectId, cslStyle)
  }
}
